/**
 * Language Toggle Component
 *
 * Flag-based toggle for switching between English and Arabic.
 */

import { useLanguage } from '../lib/language-context';

export function LanguageToggle() {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 border-0 bg-transparent text-xs font-medium text-slate-600 hover:text-sky-600 transition-colors cursor-pointer"
      aria-label={language === 'en' ? 'Switch to Arabic' : 'Switch to English'}
    >
      {language === 'en' ? (
        <>
          <span className="text-base leading-none">🇦🇪</span>
          <span>AR</span>
        </>
      ) : (
        <>
          <span className="text-base leading-none">🇺🇸</span>
          <span>EN</span>
        </>
      )}
    </button>
  );
}
